export default "__VITE_ASSET__Cgfihlw5__"